import { useEffect, useState } from "react";
import { siteApi } from "../api";
import { PageHero, PromoCard, Empty } from "./parts";

export default function OffersPage() {
  const [promos, setPromos] = useState(null);
  useEffect(() => { siteApi.get("/website/promotions").then((r) => setPromos(r.data)).catch(() => setPromos([])); }, []);
  return (
    <>
      <PageHero eyebrow="Angebote" title="Aktuelle Aktionen" text="Entdecken Sie unsere zeitlich begrenzten Angebote." />
      <div className="max-w-6xl mx-auto px-5 py-12 sm:py-16" data-testid="offers-list">
        {promos && promos.length === 0 && <Empty>Zurzeit gibt es keine aktiven Angebote. Schauen Sie bald wieder vorbei.</Empty>}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">{(promos || []).map((p) => <PromoCard key={p.id} p={p} />)}</div>
      </div>
    </>
  );
}
